import myzxios from '../utils/myaxios'

export function oneLinkAuthCardInfo(data){
    return myzxios({
        url: '/manager/oneLinkAuth/cardInfo',
        data,
        method: 'POST'
    })
}

export function sendSmsCode(data){
    return myzxios({
        url: '/manager/oneLinkAuth/sendSmsCode',
        data,
        method: 'POST'
    })
}



// 终端认证
export function terminalAuth(data){
    return myzxios({
        url: '/manager/oneLinkAuth/terminalAuth',
        data,
        method: 'POST'
    })
}

// 终端上线
export function terminalOnline(data){
    return myzxios({
        url: '/manager/oneLinkAuth/terminalOnline',
        data,
        method: 'POST'
    })
}